import { cn } from "@/lib/cn";

/** File extension for each provider mark under `/brand/providers/`. */
const PROVIDER_LOGO_EXT: Record<string, "svg" | "png"> = {
  zoom: "svg",
  google_meet: "svg",
  google_forms: "svg",
  linkedin_events: "svg",
  heysummit: "svg",
  fluent_forms: "svg",
  constant_contact: "svg",
  mailchimp: "svg",
  eventbrite: "svg",
  microsoft_teams: "svg",
  neon: "png",
  salesforce: "svg",
  hubspot: "svg",
  zoho: "svg",
  dynamics: "svg",
  pipedrive: "png",
  blackbaud: "png",
  civicrm: "svg",
  bloomerang: "png",
  donorperfect: "png",
  everyaction: "png",
  nationbuilder: "png",
};

export function providerLogoSrc(provider: string): string | null {
  const id = provider.trim().toLowerCase();
  const ext = PROVIDER_LOGO_EXT[id];
  if (!ext) return null;
  return `/brand/providers/${id}.${ext}`;
}

export function ProviderLogo({
  provider,
  label,
  className,
}: {
  provider: string;
  label?: string;
  className?: string;
}) {
  const src = providerLogoSrc(provider);
  if (!src) {
    return (
      <span
        className={cn(
          "flex size-10 shrink-0 items-center justify-center rounded-rs-sm bg-rs-muted text-sm font-semibold text-rs-ink-muted",
          className,
        )}
        aria-hidden
      >
        {(label ?? provider).slice(0, 1).toUpperCase()}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt=""
      width={40}
      height={40}
      decoding="async"
      className={cn(
        "size-10 shrink-0 rounded-rs-sm border border-rs-border bg-rs-elevated object-contain p-1",
        className,
      )}
      aria-hidden
    />
  );
}
